'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { GoArrowRight } from 'react-icons/go';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function CategoryBanner({
  category,
  className,
}: {
  category: CategoriesEntity;
  className?: { section?: string };
}) {
  const { t } = useTranslations();

  return (
    <section className={cn('custom-section py-6', className?.section)}>
      <div
        className={cn(
          'custom-container',
          'relative flex h-[400px] flex-col items-start justify-between overflow-hidden rounded-[4px] p-[18px] sm:h-[450px] sm:p-5 lg:h-[550px] lg:p-6',
        )}
      >
        <p className="relative z-10 flex h-[30px] items-center justify-center rounded-[4px] bg-[#FAF6E5] px-3 text-xs font-semibold uppercase text-black">
          {t('text749')}
        </p>
        <div className="relative z-10 flex w-full flex-col items-start justify-start gap-6 sm:flex-row sm:items-end sm:justify-between">
          <h3 className={cn('h1', 'w-full max-w-[460px] font-semibold uppercase text-white')}>
            {category?.name}
          </h3>
          <Button asChild variant={'white'}>
            <Link prefetch={false} href={ROUTES.CATEGORY({ slug: category?.slug })}>
              {t('text1993')} <GoArrowRight size={20} />
            </Link>
          </Button>
        </div>
        <div
          className={cn(
            'absolute inset-0 z-[1] h-full w-full',
            'ea-category-banner__image-overlay',
          )}
        />
        <Image
          src={category?.image?.url ?? ''}
          alt={resolveImageAlt(category?.image, category?.name, category?.name || 'Category Banner')}
          width={0}
          height={0}
          className="absolute inset-0 z-0 h-full w-full object-cover object-center"
          sizes="100vw"
        />
      </div>
    </section>
  );
}
